Monitoring.Views ||= {}

class Monitoring.Views.ReviewStarsView extends Backbone.View
  template: JST["backbone/templates/review_stars"]
  tagName: 'span'

  render: =>
    @$el.html(@template)
    @

  setRating: (starNumber) ->
    for rating in _.range(1, starNumber  + 1)
      @$el.find("#star#{rating}").prop('checked', true)
